import React from 'react';
import { stylesColors } from 'angieslist-styles';
import { Button, Col, Panel, Row } from 'angieslist-react-components';

type Props = {
  licensingAttested: boolean,
  onAttest: () => void,
}

const ReviewLicensingPanel = ({
  licensingAttested,
  onAttest,
}: Props) =>
  (
    <Row>
      <Col xs={12}>
        <Panel id="Review-Licensing-Panel">
          <Panel.Body style={{ backgroundColor: stylesColors.secondary300 }}>
            <Row style={{ display: 'flex', alignItems: 'center' }}>
              <Choose>
                <When condition={!licensingAttested}>
                  <Col xs={6} md={7} lg={8} style={{ color: stylesColors.white }}>
                    <h4>
                      Review Your Licensing
                    </h4>
                    Please confirm that you hold appropriate licensing for
                    your trade(s) and any required licenses listed below.
                  </Col>
                  <Col xs={6} md={5} lg={4}>
                    <Button
                      id="Review-License-Panel--Confirm-Licensing-Button"
                      bsSize="small"
                      bsStyle="default-office"
                      block
                      type="submit"
                      onClick={onAttest}
                    >Confirm
                    </Button>
                  </Col>
                </When>
                <Otherwise>
                  <Col xs={12} style={{ color: stylesColors.white, textAlign: 'center' }}>
                    Thank you for confirming!
                  </Col>
                </Otherwise>
              </Choose>
            </Row>
          </Panel.Body>
        </Panel>
      </Col>
    </Row>
  );


export default ReviewLicensingPanel;



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ReviewLicensingPanel.js